import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "src/App";
import "src/core/assets/styles/index.css";
import "src/core/i18n";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
